module.exports = __webpack_public_path__ + "img/spezialisierungen_320.03f50ee2.png";